import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup } from "components";

import styles from "../terminalSolution.module.scss";

type AdditionalInfoProps = {
	isLoading: boolean;
};

const AdditionalInfo = ({ isLoading = false }: AdditionalInfoProps) => {
	const { register } = useFormContext();

	return (
		<div
			className={styles.section}
			data-autotest="additionalInformationSection"
		>
			<Row>
				<Col md={5}>
					<HookFormInputGroup
						name="term"
						register={register}
						label="Term"
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						readOnly
					/>
				</Col>
				<Col md={{ offset: 2, span: 5 }}>
					<HookFormInputGroup
						name="applicationName"
						register={register}
						label="Application Name"
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						readOnly
					/>
				</Col>
			</Row>
		</div>
	);
};

export default AdditionalInfo;
